import { render, staticRenderFns } from "./LoginWidget.vue?vue&type=template&id=571cc091&scoped=true&"
import script from "./LoginWidget.vue?vue&type=script&lang=js&"
export * from "./LoginWidget.vue?vue&type=script&lang=js&"
import style0 from "./LoginWidget.vue?vue&type=style&index=0&id=571cc091&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cc091",
  null
  
)

export default component.exports